import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { job, grayBackground } from "./JobHtmlRenderer.css.mjs";
const UnsafeJobHtmlRenderer = ({
  background = "white",
  children
}) => /* @__PURE__ */ jsx(
  Box,
  {
    className: [
      job,
      background === "gray" ? grayBackground : void 0
    ],
    dangerouslySetInnerHTML: {
      __html: children
    }
  }
);
export {
  UnsafeJobHtmlRenderer
};
